module.exports = __webpack_public_path__ + "img/stopwatch.b6f89e9d.svg";